import { ListScaffold, type ListRow } from "@/components/ListScaffold";

// Declinations (presentational scaffolding). Mirrors the Submissions tab; not
// wired. Carrier is the market that declined.
const ROWS: ListRow[] = [
  {
    id: "DEC-8801",
    account: "Acme Builders LLC",
    coverage: "General Liability",
    date: "2026-01-20",
    status: "declined",
    carrier: "Travelers",
  },
  {
    id: "DEC-8802",
    account: "Ironwood Construction",
    coverage: "Workers Compensation",
    date: "2026-01-05",
    status: "declined",
    carrier: "Pie",
  },
  {
    id: "DEC-8803",
    account: "Harbor Freight Co",
    coverage: "Commercial Auto",
    date: "2025-12-18",
    status: "declined",
    carrier: "Progressive",
  },
];

export function DeclinationsPage() {
  return (
    <ListScaffold
      title="Declinations"
      subtitle="Markets that declined to quote your submissions."
      idLabel="Reference"
      dateLabel="Declined"
      noun="declinations"
      rows={ROWS}
    />
  );
}
